module.exports = __webpack_public_path__ + "static/media/dish_card8.4bdbf619.png";